var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg056Minimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9999 1.9942C21.2666 1.9942 21.5222 2.10069 21.7099 2.29C21.8993 2.47777 22.0057 2.73336 22.0057 3C22.0057 3.26664 21.8993 3.52223 21.7099 3.71L16.4099 9H20.9999C21.5522 9 21.9999 9.44772 21.9999 10C21.9999 10.5523 21.5522 11 20.9999 11H13.9999C13.4477 11 12.9999 10.5523 12.9999 10V3C12.9999 2.44772 13.4477 2 13.9999 2C14.5522 2 14.9999 2.44772 14.9999 3V7.59L20.2899 2.29C20.4777 2.10069 20.7333 1.9942 20.9999 1.9942ZM8.99994 16.41L3.70994 21.71C3.52217 21.8993 3.26658 22.0058 2.99994 22.0058C2.7333 22.0058 2.47771 21.8993 2.28994 21.71C2.10063 21.5222 1.99414 21.2666 1.99414 21C1.99414 20.7334 2.10063 20.4778 2.28994 20.29L7.58994 15H2.99994C2.44765 15 1.99994 14.5523 1.99994 14C1.99994 13.4477 2.44765 13 2.99994 13H9.99994C10.5522 13 10.9999 13.4477 10.9999 14V21C10.9999 21.5523 10.5522 22 9.99994 22C9.44765 22 8.99994 21.5523 8.99994 21V16.41Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg056Minimize);
export default __webpack_public_path__ + "static/media/056-minimize.c515bda45cffa5275a243495b992ae82.svg";
export { ForwardRef as ReactComponent };